exports.computeSelectionXpos = boundingBox => boundingBox.get('x');
